import { render, staticRenderFns } from "./dong6.vue?vue&type=template&id=68edea0a&scoped=true&"
import script from "./dong6.vue?vue&type=script&lang=js&"
export * from "./dong6.vue?vue&type=script&lang=js&"
import style0 from "./dong6.vue?vue&type=style&index=0&id=68edea0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68edea0a",
  null
  
)

export default component.exports